import qs from 'qs'
import { getToken } from '@/utils/cookie'
import request from '@/utils/request'

/**
 * @param {{name?: string, email?: string, "region.id": number, "region.same": boolean}} params
 * @returns {{users: User[]}}
 */
export function getUsers(params) {
  return request({
    url: `/api/users/`,
    method: 'get',
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
  })
}

export function getVrioUsers(params) {
  return request({
    url: `/api/users/vrio/`,
    method: 'get',
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    params,
  })
}

export function postVrioUser(data) {
  return request({
    url: `/api/users/vrio/`,
    method: 'post',
    data,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  })
}

export function getTokenVrioUser(id) {
  return request({
    url: `/api/users/vrio/${id}/`,
    method: 'get',
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  })
}

export function deleteVrioUser(id) {
  return request({
    url: `/api/users/vrio/${id}/`,
    method: 'delete',
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  })
}

export function patchVrioUser(id, data) {
  return request({
    url: `/api/users/vrio/${id}/`,
    method: 'patch',
    data,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  })
}
